// --- IntroductionSection ---
export const STATIC_INTRO_DATA = {
	totalItems: 21209,
	// Illustrative values matching the Figma mock — replace with real data in the live data phase
	breakdown: {
		pages: 11299,
		workItems: 4821,
		videos: 1203,
		designs: 987,
		pullRequests: 2341,
		comments: 558,
	},
	topPercentile: 10, // "You're in the top 10%"
};

// --- GraphPreviewSection ---
export const STATIC_GRAPH_PREVIEW_DATA = {
	relationshipsCreated: 891123,
};

// --- ConnectedAppsSection ---
export const STATIC_CONNECTED_APPS_DATA: {
    connectedApps: {
        name: string;
        source: string;
        itemCount: number;
        color: string;
    }[];
    // Number of apps to show before "Show N more" expands the rest
    initialVisibleCount: number; suggestedApps: {
        name: string;
        source: string;
        teammatesUsing: number;
    }[];
} = {
	connectedApps: [
		{ name: 'Figma', source: 'figma', itemCount: 190, color: '#82B536' },
		{ name: 'GitHub', source: 'github', itemCount: 129, color: '#BF63F3' },
		{ name: 'Google Drive', source: 'google_drive', itemCount: 98, color: '#FCA700' },
		{ name: 'Loom', source: 'loom', itemCount: 78, color: '#1868DB' },
		{ name: 'Confluence', source: 'confluence', itemCount: 89, color: '#82B536' },
		// Hidden by default — revealed by "Show N more"
		{ name: 'Jira', source: 'jira', itemCount: 64, color: '#BF63F3' },
		{ name: 'Slack', source: 'slack', itemCount: 51, color: '#4D8CED' },
		{ name: 'Google Calendar', source: 'google_calendar', itemCount: 38, color: '#FCA700' },
		{ name: 'Microsoft Teams', source: 'teams', itemCount: 27, color: '#82B536' },
		{ name: 'Miro', source: 'miro', itemCount: 19, color: '#8C8F97' },
		{ name: 'Microsoft SharePoint', source: 'microsoft_sharepoint', itemCount: 14, color: '#1868DB' },
	],
	// Number of apps to show before "Show N more" expands the rest
	initialVisibleCount: 5,
	suggestedApps: [
		{ name: 'Google Calendar', source: 'google_calendar', teammatesUsing: 321 },
		{ name: 'Sharepoint', source: 'microsoft_sharepoint', teammatesUsing: 321 },
		{ name: 'Teams', source: 'teams', teammatesUsing: 321 },
	],
};

// --- CollaboratorsSection ---
// Avatar URLs sourced from MOCK_COLLABORATION_USERS in src/utils/mocks.ts
export const STATIC_COLLABORATORS_DATA: {
    totalCollaborators: number;
    collaborators: {
        name: string;
        sharedItems: number;
        score: number;
        avatarUrl: string;
    }[];
} = {
	totalCollaborators: 744,
	collaborators: [
		{
			name: 'Ashish Kumar',
			sharedItems: 128,
			score: 987,
			avatarUrl: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/63749bd0213a315af345637f/2b6c2fa6-2e99-4c40-98a4-73ec192829af/128',
		},
		{
			name: 'Parth Mehta',
			sharedItems: 112,
			score: 854,
			avatarUrl: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/712020:09586fae-19c1-4ffd-a4d3-06e8825ed043/a82fcef7-5024-4f91-9c2e-77e0f4a80f61/128',
		},
		{
			name: 'Hamza Shahid',
			sharedItems: 98,
			score: 743,
			avatarUrl: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/70121:f604320b-d57f-4347-9af4-6134863803c2/371838a1-9613-4320-8e6e-b0542872590a/128',
		},
		{
			name: 'Neel Dutta',
			sharedItems: 87,
			score: 631,
			avatarUrl: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/63749bf65fce844d606712e6/c8f3eb84-f065-4e52-92c5-baac27ed7e6f/128',
		},
		{
			name: 'Hilda Nguyen',
			sharedItems: 74,
			score: 512,
			avatarUrl: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/712020:0caa1169-1fef-4444-91fc-74516b0494fc/1ff07445-0f8e-464c-8833-36db2282065e/128',
		},
	],
};

// --- UserGraphSection ---
export const STATIC_USER_GRAPH_DATA = {
	items: 11299,
	relationships: 891123,
	apps: 11,
	collaborators: 744,
};
